
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Icon","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 999.93 944.88"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"cls-1",attrs:{"d":"M717.73 827.87H282.27a98.26 98.26 0 01-86.11-145.61l217.73-396A98.26 98.26 0 01500 235.34a98.25 98.25 0 0186.11 50.92l217.73 396a98.26 98.26 0 01-86.11 145.61zM487.5 326.73l-217.73 396a14.26 14.26 0 0012.5 21.14h435.46a14.26 14.26 0 0012.5-21.14l-217.73-396a14.27 14.27 0 00-25 0z","transform":"translate(-.04 -27.56)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M500 625.64a26.91 26.91 0 01-26.83-24.89L463 464.74a26.91 26.91 0 0126.83-28.92h20.44a26.91 26.91 0 0126.83 28.92l-10.22 136a26.91 26.91 0 01-26.88 24.9z","transform":"translate(-.04 -27.56)"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"470.79","y":"628.38","width":"58.35","height":"58.35","rx":"22.27"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M384.48 248a131.7 131.7 0 01231 0l3.51 6.38V27.56H381v226.83z","transform":"translate(-.04 -27.56)"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M380.94 855.96h238.05v88.92H380.94z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M761.91 139.74v374.53l95.62 173.91A131.63 131.63 0 01761.91 882v90.43H1000V139.74zM190.78 865.21a131.71 131.71 0 01-48.31-177l95.62-173.91v-63.49H0v521.63h238.09V882a131.09 131.09 0 01-47.31-16.79z","transform":"translate(-.04 -27.56)"}})])
          )
        }
      }
    